import { millisecondsInMinute } from '@alltrails/data-formatting/dateConstants';

export const trailConditionsIntervalMin = 30;
export const trailConditionsIntervalMs = trailConditionsIntervalMin * millisecondsInMinute;
